export default __webpack_public_path__ + "media/images/icons/arrow-white-prev-526db34700bbcc068b77b400b7fa3611.png";